import { type IBudgetCustomFieldConditionValue } from '@webapp/platform/budgets'

const CUSTOM_FIELD_CONDITION_COUNT = 3

const EMPTY_CUSTOM_FIELD_CONDITION: IBudgetCustomFieldConditionValue = {
  field: null,
  values: [],
}

export const formatCustomFieldConditionFormRows = (
  customFieldConditions: IBudgetCustomFieldConditionValue[] = []
): IBudgetCustomFieldConditionValue[] =>
  Array.from(
    { length: CUSTOM_FIELD_CONDITION_COUNT },
    (_, index) => customFieldConditions[index] ?? EMPTY_CUSTOM_FIELD_CONDITION
  )

export const hasCustomFieldCondition = (
  customFieldConditions?: IBudgetCustomFieldConditionValue[]
) =>
  !!customFieldConditions?.some(
    (customFieldCondition) => customFieldCondition.field
  )
